// @systeme: interface
// Les chiffres : foyers, abonnements, conversion, résiliations, marge. Jamais un contenu.
import { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { TableauDeBord } from '@foyer/shared';
import { Chargement } from '../../composants/Chargement';
import { useMessages } from '../../composants/Messages';
import { api } from '../../lib/api';

export function Chiffres() {
  const { direErreur } = useMessages();
  const [tableau, setTableau] = useState<TableauDeBord | undefined>();

  useEffect(() => {
    api.admin.tableauDeBord().then(setTableau).catch(direErreur);
  }, [direErreur]);

  if (!tableau) return <Chargement />;
  const a = tableau.abonnements;
  const cartes: { libelle: string; valeur: string | number }[] = [
    { libelle: 'Foyers', valeur: tableau.foyers },
    { libelle: 'Utilisatrices', valeur: tableau.utilisatrices },
    { libelle: 'À l’essai', valeur: a['essai'] ?? 0 },
    { libelle: 'Abonnés', valeur: a['actif'] ?? 0 },
    { libelle: 'Essais terminés sans abonnement', valeur: a['expire'] ?? 0 },
    { libelle: 'Impayés', valeur: a['impaye'] ?? 0 },
    {
      libelle: 'Conversion essai → payant',
      valeur:
        tableau.tauxConversion === null ? '—' : `${Math.round(tableau.tauxConversion * 100)} %`,
    },
    { libelle: 'Résiliations sur trente jours', valeur: tableau.resiliationsTrenteJours },
    {
      libelle: 'Durée de vie moyenne d’un abonnement',
      valeur: tableau.dureeVieMoyenneJours === null ? '—' : `${tableau.dureeVieMoyenneJours} j`,
    },
    { libelle: 'Foyers qui coûtent plus qu’ils ne paient', valeur: tableau.foyersDeficitaires },
    { libelle: 'Captures sur trente jours', valeur: tableau.capturesTrenteJours },
    { libelle: 'Retours à traiter', valeur: tableau.retoursNonTraites },
    { libelle: 'Accès support ouverts', valeur: tableau.accesSupportOuverts },
    { libelle: 'Suppressions de compte en attente', valeur: tableau.suppressionsEnAttente },
    { libelle: 'Séries du banc en cours', valeur: tableau.bancsEnCours },
    {
      libelle: `IA aujourd’hui${tableau.plafondIaJour > 0 ? ` (plafond ${tableau.plafondIaJour.toFixed(2).replace('.', ',')} €)` : ''}`,
      valeur: `${tableau.depenseIaAujourdhui.toFixed(2).replace('.', ',')} €`,
    },
  ];
  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
      {cartes.map((c) => (
        <Paper key={c.libelle} variant="outlined" sx={{ p: 2, minWidth: 160, flex: 1 }}>
          <Typography variant="h2" component="p">
            {c.valeur}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {c.libelle}
          </Typography>
        </Paper>
      ))}
    </Stack>
  );
}
